export default "__VITE_ASSET__m9hy2Mcx__"